import {PostHelpDeskNewSacParams} from 'domain/usecases';
import {makePostHelpDeskNewSac} from 'main/factories/usecases';

export async function postMessage(params: PostHelpDeskNewSacParams) {
	const request = {...params};
	if (!request?.phone) {
		request.phone = '';
	}

	const response = await makePostHelpDeskNewSac().post(request);

	return response;
}
